<template>
  <div>
    <luci-btn-icon :config="backBtnConfig" @callback="$router.push({ name: 'GameList' })"></luci-btn-icon>

    <v-alert v-if="error" :value="true" color="error" icon="error" class="error-container">
      <span class="error-span luci-text white--text">{{ error }}</span>
    </v-alert>

    <div v-if="isLoading" class="loading">
      <img src="../../assets/images/icons/loading-pmc.gif" alt="'Loading">
    </div>

    <div v-if="!isLoading">
      <luci-form :config="formConfig" v-model="formData" @submit="submitForm" @reset="resetForm" @callback="$router.push({ name: 'GameList' })"></luci-form>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { cloneDeep } from 'lodash'

import variables from '../../helpers/variables'

const { mapGetters, mapActions } = createNamespacedHelpers('game/create')

export default {
  data () {
    const data = {
      backBtnConfig: variables.backBtnIconOptions,
      defaultFormData: { active: false, name: '', description: '' }
    }
    data.formData = cloneDeep(data.defaultFormData)
    return data
  },
  computed: {
    ...mapGetters([
      'error',
      'isLoading',
      'created',
      'violations'
    ]),
    formConfig () {
      return (
        {
          name: 'form-add-game',
          title: 'Details',
          description: 'To add a new game please fill in the form below',
          showButtonAsIcon: true,
          buttons: variables.formBtnIconOptions,
          fields: [
            {
              order: 1,
              element: 'input',
              required: true,
              name: 'name',
              label: 'name',
              inputConfig: { type: 'text', placeholder: 'Please enter game name', clearable: true }
            },
            {
              order: 2,
              element: 'textarea',
              required: true,
              name: 'description',
              label: 'description',
              textareaConfig: { placeholder: 'Please enter game description', clearable: true }
            }
          ]
        }
      )
    }
  },
  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }
      this.$router.push({ name: 'GameList' })
    }
  },
  methods: {
    ...mapActions([
      'create',
      'reset'
    ]),
    resetForm () {
      this.reset()
      this.formData = cloneDeep(this.defaultFormData)
    },
    submitForm () {
      this.create(this.formData)
    }
  }
}
</script>
